import { render, staticRenderFns } from "./SetWebhookCard.vue?vue&type=template&id=5a2e5f04&"
import script from "./SetWebhookCard.vue?vue&type=script&lang=ts&"
export * from "./SetWebhookCard.vue?vue&type=script&lang=ts&"
import style0 from "./SetWebhookCard.vue?vue&type=style&index=0&id=5a2e5f04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports